import React from 'react'
import { Request } from 'src/common/components'
import { RequestType } from 'src/common/static'

const Mint: React.FC = () => {
  return <Request type={RequestType.MINT} />
}

export default Mint
